import cx from 'classnames';
import React from 'react';
import { Indicator } from '../indicator/index.js';
import { calculateIndicatorGroupSvgAttributes } from '@tesla/design-system';
import { useId } from '../index.js';
export const IndicatorGroup = ({ className, dir, indicators, indicatorSize, overlap = false, ...rest }) => {
    const uid = useId();
    const isRtl = (dir || getComputedStyle(document.body).direction) === 'rtl';
    const numIndicators = indicators.length;
    const svgAttributes = calculateIndicatorGroupSvgAttributes({
        id: uid,
        isRtl,
        numIndicators,
        overlapIndicators: overlap,
    });
    return (React.createElement("svg", { className: cx('tds-indicator-group', {
            [`tds-indicator-group--${indicatorSize}-indicators`]: !!indicatorSize,
            'tds-indicator-group--overlap': overlap,
        }, className), overflow: "visible", xmlns: "http://www.w3.org/2000/svg", ...svgAttributes.container, ...rest },
        React.createElement("defs", null, indicators.map((indicator, i) => {
            const maskAttributes = svgAttributes.masks[i];
            return (React.createElement("mask", { key: indicator.color, ...maskAttributes.container },
                React.createElement("rect", { fill: "#fff", ...maskAttributes.rectVisible }),
                overlap && i !== numIndicators - 1 && (React.createElement("rect", { fill: "#000", ...maskAttributes.rectHidden }))));
        })),
        indicators.map((indicator, i) => {
            const indicatorAttributes = svgAttributes.indicators[i];
            return (React.createElement(Indicator, { key: indicator.color, ...indicator, ...indicatorAttributes.container, circleProps: indicatorAttributes.circle }));
        })));
};
